import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AtrtributeTshirtSizeDTO, EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { updateAttributeItemList } = EventsApiService();

export const useUpdateAttributeItemList = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: AtrtributeTshirtSizeDTO) => {
            return updateAttributeItemList(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success('item-list updated successfully');
            },
        },
    );
};
